import { render, staticRenderFns } from "./nav2.vue?vue&type=template&id=ca6d6c7e&scoped=true"
import script from "./nav2.vue?vue&type=script&lang=js"
export * from "./nav2.vue?vue&type=script&lang=js"
import style0 from "./nav2.vue?vue&type=style&index=0&id=ca6d6c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6d6c7e",
  null
  
)

export default component.exports